import { ExternalLink, Lock } from 'lucide-react';

interface SharePointAccessModalProps {
  webUrl: string;
  onClose: () => void;
}

export function SharePointAccessModal({ webUrl, onClose }: SharePointAccessModalProps) {
  const handleOpen = () => {
    window.open(webUrl, '_blank');
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />

      {/* Modal */}
      <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="flex items-center justify-center w-10 h-10 rounded-full bg-orange-50">
            <Lock className="w-5 h-5 text-orange-600" />
          </div>
          <h3 className="text-lg font-semibold text-slate-900">SharePoint access required</h3>
        </div>

        <p className="text-sm text-slate-600 mb-2">
          This document is hosted on SharePoint Online. Opening it requires a Microsoft account
          with access to this organization's tenant.
        </p>
        <p className="text-sm text-slate-500 mb-6">
          If you don't have access, you'll see a Microsoft sign-in page instead.
        </p>

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-slate-700 bg-slate-100 rounded-md hover:bg-slate-200 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleOpen}
            className="px-4 py-2 text-sm font-medium text-white bg-orange-600 rounded-md hover:bg-orange-700 transition-colors flex items-center gap-1.5"
          >
            Open in SharePoint
            <ExternalLink className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
    </div>
  );
}
